export default __webpack_public_path__ + "static/media/three.5264ee95.jpeg";